import React from 'react';
import { Grid, makeStyles, Theme, Typography, Hidden } from '@material-ui/core';
import { useAsset } from 'hooks';
import { Asset } from 'components/AssetListView';
import AssetVO from 'commons/vo/AssetVO';
import useWkblVideo from 'hooks/useWkblVideo';
import WkblVideoVO from 'commons/vo/WkblVideoVO';
import clsx from 'clsx';
import { useStyles } from 'components/AssetListView/styles';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/reducers/type';

function AssetListView() {
  const classes = useStyles();
  const { videoList, isLoading, pagination } = useSelector((state: RootState) => state.wkblVideo);

  return (
    <div className={classes.root}>
      <Hidden mdDown>
        <div className={clsx(classes.headerContainer, classes.row)}>
          <span className={clsx(classes.headerColumn, classes.seasonContainer)}>시즌</span>
          <span className={clsx(classes.headerColumn, classes.typeContainer)}>구분</span>
          <span className={clsx(classes.headerColumn, classes.titleContainer)}>콘텐츠 명</span>
          <span className={clsx(classes.headerColumn, classes.teamContainer)}>홈팀</span>
          <span className={clsx(classes.headerColumn, classes.teamContainer)}>원정팀</span>
          <span className={clsx(classes.headerColumn, classes.gameDateContainer)}>경기 일자</span>
          <span className={clsx(classes.headerColumn, classes.menuContainer)}>메뉴</span>
        </div>
      </Hidden>
      {videoList.map((asset: WkblVideoVO, index: number) => (
        <Asset key={`${asset.id}_${index}`} asset={asset} index={index} />
      ))}
    </div>
  );
}

export default AssetListView;
